import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import '../../../assets/scss/farm-monitor.scss';
import {
    setFarmId, cancelPreviousFarmMonitorRequest,
    refreshFarmMonitor, clearFarmMonitor, getLoadHistory
} from '../../actions/farm-monitor';
import { connectSocket, disconnectSocket } from '../../actions/socket';
import DeviceList from './Qapp/DeviceList';
import { isToday } from "../../helpers/common";
import Summary from "./Summary/Summary";
import FieldCards from "./Fields/FieldCards";
import { getDateRangeInfo } from "../../actions/analyze";
import { HARVESTING_PLAN_TYPE_ID } from "../../constants";

const haveQappLogs = false;

const FarmMonitor = (props) => {
    const { selectedPlanTypeId, farmMonitorFarmId, isRequestingPlanPlannedToDate, refreshCount,
        search: { range, rangeId } } = props;
    const farmId = props.match.params.farmId;
    let timerId = null;

    useEffect(() => {
        if (!window.socketClient) props.actions.connectSocket();
        if (farmId !== farmMonitorFarmId) props.actions.setFarmId(farmId);

        return () => {
            props.actions.cancelPreviousFarmMonitorRequest();
            props.actions.clearFarmMonitor();
            props.actions.disconnectSocket();
        };
    }, [farmId]);

    useEffect(() => {
        props.actions.cancelPreviousFarmMonitorRequest();
    }, [rangeId]);

    useEffect(() => {
        if (isToday(range) && refreshCount !== 0) props.actions.refreshFarmMonitor();
    }, [selectedPlanTypeId]);

    useEffect(() => {
        if (farmMonitorFarmId) getLoadHistory(true);
    }, [rangeId, farmMonitorFarmId, isRequestingPlanPlannedToDate, selectedPlanTypeId]);

    useEffect(() => {
        if (refreshCount !== 0 && farmMonitorFarmId) getLoadHistory(false);
    }, [refreshCount]);

    useEffect(() => {
        clearTimer();

        if (isToday(range)) timerId = setInterval(() => props.actions.refreshFarmMonitor(), 5 * 60 * 1000);
        return clearTimer;
    }, [refreshCount, range]);

    const clearTimer = () => {
        if (timerId) clearInterval(timerId);
        timerId = null;
    };

    const getLoadHistory = (haveRequest) => {
        if (selectedPlanTypeId !== HARVESTING_PLAN_TYPE_ID) return;
        const cb = (dateInfo) => {
            const params = { farmId: farmMonitorFarmId, planTypeId: HARVESTING_PLAN_TYPE_ID, haveRequest, ...dateInfo };
            props.actions.getLoadHistory(params);
        }

        props.actions.getDateRangeInfo({ farmId: farmMonitorFarmId, planTypeId: selectedPlanTypeId }, cb);
    }

    return <div className="container-farm-analyse d-flex">
        <div className={`farm-details ${haveQappLogs && "have-qapp-logs"}`} >
            <Summary />
            <FieldCards />
        </div>
        {haveQappLogs && <div className="q-app">
            <DeviceList />
        </div>}
    </div>
}


const mapStateToProps = state => {
    const farmId = state.farmMonitor.farmId;
    const selectedPlanTypeId = state.farmMonitor.selectedPlanTypeId;
    const planPlannedToDate = farmId && state.analyze.searchParams.plannedTodate[`${farmId}_${selectedPlanTypeId}`]
        ? state.analyze.searchParams.plannedTodate[`${farmId}_${selectedPlanTypeId}`] : null;


    return ({
        farmMonitorFarmId: farmId,
        selectedPlanTypeId,
        isRequestingPlanPlannedToDate: planPlannedToDate ? planPlannedToDate.isRequesting : false,
        refreshCount: state.farmMonitor.refreshCount,
        search: {
            range: state.analyze.searchParams.range,
            rangeId: state.analyze.searchParams.rangeId
        }
    });
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        setFarmId, cancelPreviousFarmMonitorRequest, clearFarmMonitor,
        refreshFarmMonitor, connectSocket, disconnectSocket, getLoadHistory, getDateRangeInfo
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmMonitor);